import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const EventsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: '100%',

  justifyContent: 'center',
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.background.secondary,
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1),
}));

export const BoxContentItem = styled(Box)(({ theme, $canEdit }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: 'fit-content',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: 'auto',
  padding: theme.spacing(0, 0, 1, 0),
  borderBottom: `1px solid ${theme.colors.borderBottom}`,
  cursor: $canEdit ? 'pointer' : 'default',
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const EmptyBoxContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minHeight: '150px',
  height: '100%',

  justifyContent: 'center',
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.background.secondary,
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1),
}));

export const EventItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  alignItems: 'flex-start',
  width: '85%',
  height: 'fit-content',
  justifyContent: 'space-between',
  color: theme.colors.white,
  '&:last-child': {
    color: theme.colors.gray,
  },
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const TimeIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
}));
